import { render, staticRenderFns } from "./TypeVocab.vue?vue&type=template&id=32ed0c7a&"
import script from "./TypeVocab.vue?vue&type=script&lang=js&"
export * from "./TypeVocab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports